var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tiptap-vuetify',{attrs:{"value":_vm.value,"extensions":_vm.extensions,"placeholder":_vm.placeholder,"card-props":{ flat: true, tile: false, outlined: true}},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }